import { PhaseInput, StoryLevelData } from "@/app/lib/levels/story-level-data-types";

const phaseInputs: PhaseInput[] = [];
// CHOICES:
const geeseRhinos = new PhaseInput(
    [
        'gAggLe',
        'geEse',
        'CrAsh',
        'rhINOs'
    ],
    'gsrhe'
)

const herd = new PhaseInput(
    [
        'heRD',
        'CAttle',
        'elepHANtS',
        'ANtelOpe'
    ],
    'lhtpe'
)

phaseInputs.push(new PhaseInput(
    [
        'POD',
        'whaleS'
    ],
    'elhwa'
))

phaseInputs.push(new PhaseInput(
    [
        'pRidE',
        'liOnS'
    ],
    'ilpnd'
))

phaseInputs.push(new PhaseInput(
    [
        'sChool',
        'fIsH'
    ],
    'lhosf'
))

phaseInputs.push(new PhaseInput(
    [
        'mUrdEr',
        'crOwS',
    ],
    'cmwrd'
))

phaseInputs.push(geeseRhinos);


export const pluralAnimals = new StoryLevelData('animal collective', 'pluralAnimals-0.0', phaseInputs);